<template>
    <div class="form-field form-options" style="margin: 0">
        <legend class="option-header">
            <span class="option-name">
                {{ t("components.shape") }}:
                <span class="option-swatch-value">
                    {{
                        selectedShape
                            ? t(`diamondProperties.shape.${selectedShape}`)
                            : t("components.noSelection")
                    }}
                </span>
            </span>
        </legend>
        <div class="ds-list">
            <diamond-shape-button
                v-for="(shape, key) in shapes"
                :key="key"
                :shape="shape"
                @click="handleDiamondShapeSelect(key)"
            />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import useStore from "@/composables/useStore";
import pick from "lodash.pick";
import DiamondShapeButton from "@/components/DiamondShapeButton.vue";
import { DiamondShapes } from "@/types/types";
import useDiamondShapeImageMap from "@/composables/useDiamondShapeImageMap";
import { useI18n } from "vue-i18n";

export default defineComponent({
    name: "DiamondShapeSelect",
    components: {
        DiamondShapeButton
    },
    setup() {
        const store = useStore();

        const diamondShapeImageMap = useDiamondShapeImageMap();

        const selectedShape = computed(() => store.state.userSelection.shape);

        const availableDiamonds = computed(() => store.state.availableDiamonds);
        const availableShapes = computed(() => {
            return [
                ...new Set(
                    availableDiamonds.value.map(diamond => diamond.shape)
                )
            ];
        });

        const shapes = computed(() =>
            pick(diamondShapeImageMap, availableShapes.value)
        );

        function handleDiamondShapeSelect(shape: DiamondShapes) {
            store.actions.setSelectedShape(shape);
        }

        return {
            ...useI18n(),
            selectedShape,
            shapes,
            handleDiamondShapeSelect
        };
    }
});
</script>
